import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAiPdfSummarizer = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#35C2FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M19.5 12h-10m10-5h-10m10 10h-10m-3.333-5A.833.833 0 1 1 4.5 12a.833.833 0 0 1 1.667 0m0-5A.833.833 0 1 1 4.5 7a.833.833 0 0 1 1.667 0m0 10A.833.833 0 1 1 4.5 17a.833.833 0 0 1 1.667 0"
    />
  </svg>
);
export default SvgAiPdfSummarizer;
